import {
  LIST_TYPES,
  type ListItemAttributes,
} from 'hb-builder/components/BuilderComponents/dynamic/List/ListLayouts/types';
import { getUrlToIndexPage } from 'hb-builder/components/BuilderComponents/dynamic/List/ListLayouts/utils/urlToIndex';
import ButtonLink from 'hb-builder/components/common/SettingsLibrary/CommonSettings/ButtonLink';
import DisplayFieldOption from 'hb-builder/components/common/SettingsLibrary/CommonSettings/DisplayFieldOption';
import TextSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/TextSetting';
import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import { useBuilderConfigContext } from 'hb-builder/hooks';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';

const ButtonSettings = ({
  item,
  onChange,
}: Pick<ComponentSettingsTab<ListItemAttributes>, 'item' | 'onChange'>) => {
  const {
    hivebrite: { ids },
    whiteLabelUrl,
  } = useBuilderConfigContext();

  const settingProps = { item, onChange };
  const { attributes } = item;
  const { type } = attributes?.dynamicAttributes || {};

  const newAttributes = {
    ...attributes,
    buttonLink:
      attributes?.buttonLink === undefined && type
        ? getUrlToIndexPage({ topicId: ids.topic, type, whiteLabelUrl })
        : attributes?.buttonLink,
  };

  const newItem = { ...item, attributes: newAttributes };
  const seeAllBtn = () => {
    switch (type) {
      case undefined:
      case LIST_TYPES.EMPTY:
        return '';
      case LIST_TYPES.TOPICS:
        return 'groups';
      default:
        return type;
    }
  };

  return (
    <AccordionTitle title={__('Button')}>
      <DisplayFieldOption
        keySetter="attributes.dynamicAttributes.button.display"
        label={__('Display Button')}
        {...settingProps}
      />
      <TextSetting
        // TODO: refacto to get a default value at the component creation
        initialValue={s__('See all %{type}').i__({
          type: seeAllBtn(),
        })}
        settingKey="buttonContent"
        title={__('Content')}
        {...settingProps}
      />
      <ButtonLink
        placeholder={__('Add your index page link here')}
        onChange={onChange}
        item={newItem}
      />
      <DisplayFieldOption
        disabled={item.attributes?.buttonLink?.startsWith('mailto:')}
        keySetter="attributes.dynamicAttributes.button.newPage"
        label={__('Open link in a new tab')}
        {...settingProps}
      />
    </AccordionTitle>
  );
};

export default ButtonSettings;
